import { h } from 'preact';

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
			<path d="M16 1l-4.001.933-8-.933L0 1.933V15l3.999-.933 8 .933L16 13.133V1zM4.5 13.118V2.066l7 .816v11.053l-7-.817zM1 2.727l2.5-.583v11.012L1 13.74V2.727zm11.5.117l2.5-.583v10.236l-2.5 1.167V2.844z" fill-rule="evenodd"/>
		</svg>
	);
};
